import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'mensajes-validacion',
	templateUrl: './mensajes-validacion.component.html',
	styleUrls: ['./mensajes-validacion.component.css']
})
export class MensajesValidacionComponent implements OnInit {

	@Input() campo: any;
	@Input() minimo: number;
	@Input() siempreVisible: boolean;
	@Input() maximo: number;
	@Input() textoValidacion: string;
	@Input() requerido: any;


	constructor() { }

	ngOnInit() {
	}

}
